import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'created'})
export class CreatedPipe implements PipeTransform {
  transform(data: any): string {
    return data.creationTime.substr(0, 19).replace('T', ' ') + (data.creationUser ? ' by ' + data.creationUser.realname : '');
  }
}
